import { StatisticsTableUnderMap } from "../../../objectsTable";

// Компонент - таблица с информацией по карте
export function MapDataTable({ className }: any) {

    return (
        <>
            <div className={`table-wrap table-wrap-under-map ${className ?? ''}`}>
                <StatisticsTableUnderMap />
            </div>
        </>
    );
}

